import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as bootstrap from "bootstrap"
import { Fancybox } from "@fancyapps/ui";
import SwipeListener from "swipe-listener"

const monthsObject = {
    ["cover"] : {
      m_pre: "dicembre",
      m_post: "gennaio",
      color: "#008CE3",
      name: {
        it: "Cover",
        en: "Cover"
      }
    },
    ["gennaio"] : {
        m_pre: "cover",
        m_post: "febbraio",
        color: "#00D400",
        name: {
            it: "Gennaio",
            en: "January"
        }
    },
    ["febbraio"] : {
        m_pre: "gennaio",
        m_post: "marzo",
        color: "#B4C400",
        name: {
            it: "Febbraio",
            en: "February"
        }
    },
    ["marzo"] : {
        m_pre: "febbraio",
        m_post: "aprile",
        color: "#8618B9",
        name: {
            it: "Marzo",
            en: "March"
        }
    },
    ["aprile"] : {
        m_pre: "marzo",
        m_post: "maggio",
        color: "#ED39E0",
        name: {
            it: "Aprile",
            en: "April"
        }
    },
    ["maggio"] : {
        m_pre: "aprile",
        m_post: "giugno",
        color: "#ED4A00",
        name: {
            it: "Maggio",
            en: "May"
        }
    },
    ["giugno"] : {
        m_pre: "maggio",
        m_post: "luglio",
        color: "#00D47F",
        name: {
            it: "Giugno",
            en: "June"
        }
    },
    ["luglio"] : {
        m_pre: "giugno",
        m_post: "agosto",
        color: "#00C6E0",
        name: {
            it: "Luglio",
            en: "July"
        }
    },
    ["agosto"] : {
        m_pre: "luglio",
        m_post: "settembre",
        color: "#E10000",
        name: {
            it: "Agosto",
            en: "August"
        }
    },
    ["settembre"] : {
        m_pre: "agosto",
        m_post: "ottobre",
        color: "#0044BD",
        name: {
            it: "Settembre",
            en: "September"
        }
    },
    ["ottobre"] : {
        m_pre: "settembre",
        m_post: "novembre",
        color: "#DE9000",
        name: {
            it: "Ottobre",
            en: "October"
        }
    },
    ["novembre"] : {
        m_pre: "ottobre",
        m_post: "dicembre",
        color: "#161FA0",
        name: {
            it: "Novembre",
            en: "November"
        }
    },
    ["dicembre"] : {
        m_pre: "novembre",
        m_post: "cover",
        color: "#EF0660",
        name: {
            it: "Dicembre",
            en: "December"
        }
    }
};

const JsFile = () => {
  /// CAROUSEL

  /*if (document.getElementById("myCarousel")){
    const myCarousel = document.querySelector('#myCarousel')
    const carousel = new bootstrap.Carousel(myCarousel)

    const listener = SwipeListener(myCarousel)
    myCarousel.addEventListener('swipe', function (e) {
    let directions = e.detail.directions;
    let x = e.detail.x;
    let y = e.detail.y;
    
    myCarousel.addEventListener('slide.bs.carousel', function () {
        
        if (directions.left) {
            e.stopPropagation();
            carousel.next();
        };
        
        if (directions.right) {
            e.stopPropagation();
            carousel.prev();
        };
        
    })
        
  })

  }*/

  

  /// GSAP PARALLAX

  gsap.registerPlugin(ScrollTrigger);
  gsap.to(".parallax-bg", {
    scrollTrigger: {
      scrub: true
    }, 
    y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
    ease: "none"
  });

  /// HEADER SCROLLTRIGGER

  const showAnim = gsap.from('.Menu', { 
    yPercent: -250,
    paused: false,
    duration: 0.2
  });


  ScrollTrigger.create({
    start: "top top",
    end: 99999,
    onUpdate: (self) => self.direction === -1 ? showAnim.play() : showAnim.reverse()
  })

  let headerHandler = 0;

  const header = gsap.to('.Menu',{
    backgroundColor: "rgb(100,100,100,.3)",
    backdropFilter: "blur(8px)",
    duration: 0.2,
    scrollTrigger:{
      target: `${document.querySelector(".experience") ? ".experience" : ".monthSideBar"}`,
      start:"bottom top",
      end:"bottom top",
      toggleActions: "play none reverse reverse",
      
      onUpdate: (self) => headerHandler = self.progress,
    }
  })

  /// INTERNAL PAGE COLOR HANDLER
  
  if(document.body.classList.contains('internalPage')){
      document.documentElement.style.setProperty("--mainColor", monthsObject[document.body.id].color);
      document.querySelector('meta[name="theme-color"]').setAttribute('content', monthsObject[document.body.id].color);
  } 

  /// MENU HANDLER

  let isOpen = false;
  if (document.getElementById("Menu")) document.getElementById("Menu").onclick = () => {
    isOpen = !isOpen;

    if (isOpen){
      header.reverse();
      showAnim.play()
    
      document.querySelector(".Menu__burgerMenu").classList.toggle("Menu__burgerMenu--close");
      document.querySelector(".Menu__burgerMenu__line__1--open").classList.toggle("Menu__burgerMenu__line__1--close");
      document.querySelector(".Menu__burgerMenu__line__2--open").classList.toggle("Menu__burgerMenu__line__2--close");
      document.querySelector(".Menu__burgerMenu__line__3--open").classList.toggle("Menu__burgerMenu__line__3--close");

      document.querySelector(".MenuModal").style.display = "block";
      gsap.to( ".MenuModal", { top: "0vh", duration: 0.8, ease: "back.out(1.7)"});
      document.body.style.overflowY = 'hidden';
      document.querySelectorAll('.svg-trigger').forEach(element => element.style.fill = document.documentElement.style.getPropertyValue("--mainColor"));
      document.getElementById("bodyegg") && document.querySelectorAll('.svg-trigger').forEach(element => element.style.fill = "#E50058");

      gsap.from (".MenuModal li",{
        opacity:0,
        duration:1,
        stagger:.05
      })
    }
    else{
      !headerHandler ? header.pause() : header.play();
      showAnim.play();
      
      document.querySelector(".Menu__burgerMenu").classList.toggle("Menu__burgerMenu--close");
      document.querySelector(".Menu__burgerMenu__line__1--open").classList.toggle("Menu__burgerMenu__line__1--close");
      document.querySelector(".Menu__burgerMenu__line__2--open").classList.toggle("Menu__burgerMenu__line__2--close");
      document.querySelector(".Menu__burgerMenu__line__3--open").classList.toggle("Menu__burgerMenu__line__3--close");

      gsap.to( ".MenuModal", { top: "-100vh", duration: 0.8, ease: "back.out(1.7)", onComplete: () => document.querySelector(".MenuModal").style.display = "none"});
      if (!document.getElementById("easter-egg")) document.body.style.overflowY = 'visible';
      if (!document.getElementsByClassName("step-end"))document.querySelectorAll('.svg-trigger').forEach(element => element.style.fill = null);
      document.querySelectorAll('.svg-trigger').forEach(element => element.style.fill = null);
    };
  }

    /// footer menu pagine interne
    if(document.body.classList.contains('internalPage')){
        if(monthsObject[document.body.id].m_pre != null){
            document.querySelector(".select-month .color-prev .image-label").classList.add('image-label-cursor-prev'); // server per il cursore
            document.querySelector(".select-month .color-prev").style.backgroundColor = monthsObject[monthsObject[document.body.id].m_pre].color;
            document.querySelector(".select-month .color-prev .mese_text").innerHTML = eval("monthsObject[monthsObject[document.body.id].m_pre].name."+document.documentElement.lang);
            document.querySelector(".select-month .color-prev").href = eval("monthsObject[monthsObject[document.body.id].m_pre].name."+document.documentElement.lang
            ).toLowerCase()+".html";
        } else {
            document.querySelector(".select-month .color-prev").style.opacity = 0;
        }
        if(monthsObject[document.body.id].m_post != null) {
            document.querySelector(".select-month .color-next .image-label").classList.add('image-label-cursor-next'); // server per il cursore
            document.querySelector(".select-month .color-next").style.backgroundColor = monthsObject[monthsObject[document.body.id].m_post].color;
            document.querySelector(".select-month .color-next .mese_text").innerHTML = eval("monthsObject[monthsObject[document.body.id].m_post].name." + document.documentElement.lang);
            document.querySelector(".select-month .color-next").href = eval("monthsObject[monthsObject[document.body.id].m_post].name." + document.documentElement.lang
            ).toLowerCase() + ".html";
        } else {
            document.querySelector(".select-month .color-next").style.opacity = 0;
        }
    }

  /// CURSOR CODEs

    let cursor = document.createElement('div');
    cursor.className= 'cursor bg-color';
    cursor.setAttribute("id","cursorID");
    document.body.appendChild(cursor);

    let isScrolling;
    let x;
    let y;
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if(!isSafari){
        let css = 'html, body, a, a:hover {cursor: none;}';
        let style = document.createElement('style');

        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        document.getElementsByTagName('head')[0].appendChild(style);

        document.querySelectorAll('[href^="https://www.youtube"]').forEach((button) => {
            button.addEventListener('mouseenter', () => {
                cursor.classList.add('viewVideo');
            });
            button.addEventListener('mouseleave', () => {
                cursor.classList.remove('viewVideo');
            });
        });
    
        const changeCursor = function(e){
            x = e.clientX;
            y = e.clientY;
            cursor.style.transform = `translate3d(calc(${x}px - 5%), calc(${y}px - 5%), 0)`;
        }
    
        document.addEventListener('mousemove', (e) => {
            changeCursor(e);
        });
        document.addEventListener('scroll', (e) => {
            window.clearTimeout( isScrolling );
            isScrolling = setTimeout(function() {
                let passP = new Object();
                passP.clientX = x;
                passP.clientY = y;
                changeCursor(passP);
            }, 100);
        });
    }
    



    /*
    // ANIMATION SECTION
    const boxes = gsap.utils.toArray('section');
    boxes.forEach(box => {
      gsap.from(box, { 
        opacity: 0,
        duration:1,
        scrollTrigger: {
          trigger: box,
          start: "top center"
        }
      })
    });
    */
};

  

export default JsFile